<template>
    <modal v-if="this.correspondenceDocument">
        <template v-slot:header>
            <h3 class="modal-title">
                Correspondentie - {{ this.correspondenceDocument.name }}
            </h3>
        </template>
        <template v-slot:body>
            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                <div class="container-fluid">
                    <div class="row">
                        <div class="bg-white col-12" v-if="this.correspondenceDocument.hasBeenMailed" v-html="this.correspondenceDocument.mailHtml"></div>
                        <div class="bg-white col-12" v-if="!this.correspondenceDocument.hasBeenMailed" v-html="this.correspondenceDocument.html"></div>
                    </div>
                </div>
            </div>
            <div v-if="this.correspondenceDocument.hasBeenMailed">
                <h5 class="my-2">
                    Bijlagen
                </h5>
                <div class="list-group list-group-flush">
                    <a @click="downloadCorrespondence(this.correspondenceDocument.id)" class="cursor-pointer">
                        <div class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-10 text-truncate">{{ this.correspondenceDocument.name }}</div>
                                        <div class="col-1">
                                            <div class="row justify-content-end">
                                                <icon name="download" :fontSize="'1.5rem'"></icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div>
                <button class="btn btn-outline-info" @click="this.$emit('closeModal')">Sluiten</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Icon from "@/components/Icon.vue";
import Modal from "../../../components/Modal.vue";
import { downloadBlobUrl } from '@/helpers/DownloadFile.js'
import { isIosDevice } from '@/helpers/IsIosDevice.js'

export default {
    name: 'personalCorrespondenceModal',
    components: {Modal, Icon},
    props: {
        idCorrespondenceDocument: null,
    },
    data () {
        return {
            correspondenceDocument: null,
        }
    },
    mounted () {
        this.fetchModalData();
    },
    methods: {
        fetchModalData() {
            if (this.idCorrespondenceDocument) {
                this.$request.post('/correspondence-detail',
                    {
                        idDocument: this.idCorrespondenceDocument
                    })
                    .then((response) => {
                        this.correspondenceDocument = response;
                    })
            }
        },
        downloadCorrespondence(idDocument) {
            this.$request.get('/correspondence-detail-download/' + idDocument, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    if (isIosDevice()) {
                        const name = this.correspondenceDocument.name;
                        downloadBlobUrl(name.toLowerCase().endsWith('.pdf') ? name : name + '.pdf', url);
                    } else {
                        window.open(url);
                    }
                })
                .catch(() => {
                    alert('Bijlage kan niet worden getoond');
                });
        }
    }
}
</script>